import { render, staticRenderFns } from "./TicketsByStatus.vue?vue&type=template&id=b36f1f0a&scoped=true&"
import script from "./TicketsByStatus.vue?vue&type=script&lang=ts&"
export * from "./TicketsByStatus.vue?vue&type=script&lang=ts&"
import style0 from "./TicketsByStatus.vue?vue&type=style&index=0&id=b36f1f0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36f1f0a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCardTitle,VSkeletonLoader})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b36f1f0a')) {
      api.createRecord('b36f1f0a', component.options)
    } else {
      api.reload('b36f1f0a', component.options)
    }
    module.hot.accept("./TicketsByStatus.vue?vue&type=template&id=b36f1f0a&scoped=true&", function () {
      api.rerender('b36f1f0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/dashboard/components/TicketsByStatus.vue"
export default component.exports